module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/area_shibuya-f558d8b094fa56b533b96d433b1fa6b3.jpg";